module.exports = __webpack_public_path__ + "static/img/back04.1effb01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back04.png
// module id = zAmX
// module chunks = 1